export const formatNumber = (num: number, unit: string = "VNĐ") =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " " + unit;
export const total = (x: number, y: number) => {
  let total = 0;
  total += x + y;
  return formatNumber(total);
};

export const handleKeyDownPreventDifferentNumber = (
  event: React.KeyboardEvent<HTMLInputElement>,
  checkDecimal: boolean = false,
  noFirstZero?: boolean
) => {
  const allowedKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  const isNumber = allowedKeys.includes(event.key);
  const isDelete = event.key === "Delete" || event.key === "Backspace";
  const isSelectAll = event.key === "a" && event.ctrlKey;
  const isPaste = event.key === "v" && event.ctrlKey;
  const isCopy = event.key === "c" && event.ctrlKey;
  const isTab = event.key === "Tab" || (event.key === "Tab" && event.shiftKey);
  const isArrow = event.key === "ArrowLeft" || event.key === "ArrowRight";
  const isDot = event.key === "." && checkDecimal;
  const currentValue = (event.target as HTMLInputElement).value;
  const position = (event.target as HTMLInputElement).selectionStart;
  const hasDot = currentValue.includes(".");

  if (noFirstZero && event.key === "0" && position === 0) {
    event.preventDefault();
    return;
  }

  if (hasDot && isNumber && currentValue.split(".")[1]?.length >= 1) {
    event.preventDefault();
    return;
  }

  if (
    (!isNumber &&
      !isDot &&
      !isDelete &&
      !isSelectAll &&
      !isArrow &&
      !isPaste &&
      !isTab &&
      !isCopy) ||
    (isDot && hasDot)
  ) {
    event.preventDefault();
  }

  if (currentValue.length >= 18 && isNumber) {
    event.preventDefault();
    return;
  }
};

export const handlePastePreventDifferentNumber = (
  event: React.ClipboardEvent<HTMLInputElement>,
  checkDecimal: boolean = false
) => {
  const clipboardData = event.clipboardData || window.Clipboard;
  let pastedData = clipboardData.getData("text/plain");

  if (checkDecimal && pastedData.includes(".")) {
    const parts = pastedData.split(".");
    pastedData = parts[0] + (parts[1] ? "." + parts[1][0] : "");

    if (parts[1]?.length > 1) {
      event.preventDefault();
      return;
    }
  }

  const isValidDecimal = /^\d+(\.\d+)?$/.test(pastedData);

  if (
    (!checkDecimal && !/^\d+$/.test(pastedData)) ||
    (checkDecimal && !isValidDecimal)
  ) {
    event.preventDefault();
  }
};
